'use strict';

export default class Composition {
  constructor(apiComposition) {
    this.id = apiComposition.id;
    this.name = apiComposition.nazwa;
    this.isSystem = apiComposition.systemowa;
    this.owner = apiComposition.user;
    this.active = false;
    this.loaded = true;
    this.loading = false;
    this.visibleForAnonymousUser = apiComposition.widocznosc_niezalogowany;
  }
};
